import { render, staticRenderFns } from "./IaCardText.vue?vue&type=template&id=9fe2aa82&scoped=true"
import script from "./IaCardText.vue?vue&type=script&setup=true&lang=ts"
export * from "./IaCardText.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./IaCardText.vue?vue&type=style&index=0&id=9fe2aa82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe2aa82",
  null
  
)

export default component.exports